import { quickLinksSearchFields } from '../../config/configuration'
import { RhyBusInputText } from '@rhybus/form-controls'
import { RhyBusPageHeader } from '@rhybus/header'
import { RhyBusQuicklinksInnerview } from '@rhybus/quicklinks'
import { ChangeEvent, useEffect, useState } from 'react'
import { getQuickLinksData } from '../../services/quicklinks'
import PageOverlay from '../../utils/controls/pageoverLay/pageoverLay'

export default function QuickLinks() {
    const [searchValue, setSearchValue] = useState('')
    const [quickLinksItems, setQuickLinksItems] = useState<any[]>([])
    const [filteredItems, setFilteredItems] = useState<any[]>([])
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        getQuickLinksData().then(setQuickLinksItems).finally(() => setIsLoading(false))
    }, [])

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchValue(e.target.value)
    }

    return (
        <main id="main-content">
            {isLoading && <PageOverlay />}
        <RhyBusPageHeader
            pageTitle={'Quick Links'} badgeCount={filteredItems.length} pageHeaderIcon="icon-rb-link-angle-thick"
            headerRightContent={
                <div className="d-flex align-items-center justify-content-end">
                    <label htmlFor="quicklinks-search" className="sr-only">Search quick links</label>
                    <RhyBusInputText
                        id="quicklinks-search"
                        type='search'
                        iconRight={true}
                        wrapperClassName='min-w-250'
                        customIcon="icon-rb-search"
                        placeholder="Search Quick Links"
                        value={searchValue}
                        onChange={handleChange}
                    />
                </div>
            }
        />
        <div className='rb-innerview-pages'>
            <RhyBusQuicklinksInnerview
                items={quickLinksItems}
                searchText={searchValue}
                searchFields={quickLinksSearchFields}
                onFilteredItemsChange={(items: any) => setFilteredItems(items)}
            />
        </div>
        </main>
    )
}
